import {Fragment} from 'react';

import {PaymentTypeService as Service} from './PaymentTypeService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';

export const List = () => {

  const header = 'Hình thức thanh toán';
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'code', header: 'Mã', width: 200, matchMode: 'contains'},
      {field: 'name', header: 'Tên', minWidth: 250, matchMode: 'contains'},
      {field: 'maxValuePayment', header: 'Giá trị max', width: 150, dataType: 'number'},
      {field: 'description', header: 'Mô tả', minWidth: 250, matchMode: 'contains'}
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {field: 'code', header: 'Mã', required: true, uppercase: true, InputTextProps: {maxLength: 50}, className: 'md:col-12'},
      {field: 'name', header: 'Tên', required: true, InputTextProps: {maxLength: 400}, className: 'md:col-12'},
      {field: 'maxValuePayment', header: 'Giá trị max', type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-12'},
      {field: 'description', header: 'Mô tả', InputTextProps: {maxLength: 400}, className: 'md:col-12'}
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem(id: string): Promise<any> {
      return Service.delete(id);
    },
    deleteItems(ids: Array<any>): Promise<any> {
      return Service.deleteMulti(ids);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
